import './App.css';
import Main from './Components/Main';

function App() {
  return (
    <div className="App">
      <Main />
      {/* <header className="App-header">
        
        <button className="btn btn-primary">Click Me</button>
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
    </div>
  );
}

export default App;
